import { useEffect, useState } from 'react';
import { IoIosAddCircle } from 'react-icons/io';
import TableOne from './TableOne'
import M from 'materialize-css/dist/js/materialize.min';


const Academics = ({ ordLevel, setOrdLevel, month, setMonth, year, setYear, subject, setSubject, board, setBoard, grade, setGrade}) => {
    const [error, setError] = useState(null);

    const addAcademic = () => {
        setError(null);

        for (let i = 0; i < ordLevel.length; i++) {
            if(ordLevel[i].subject === subject)  {
                setError('Sorry, you cannot duplicate subject.')
                return;
            }         
        }

        if(month !== '' && year !== '' && subject !== '' && board !== '' && grade !== '') {
            setError(null);
            let data = {
                month,
                year,
                subject,
                board,
                grade
            }

            setOrdLevel([...ordLevel, data]);
            setYear('');
            setSubject('');
            setBoard('');
        } else {
            setError('Please provide all the details.');

        }
       
    }

    useEffect(() => {
        var elems = document.querySelectorAll('select');
        M.FormSelect.init(elems, {
            dropdownOptions: {
                coverTrigger: false, 
                hover: true
            }
        });
     
    }, []);
    return ( 
        <>
            <h5 className="title is-size-5-touch has-text-weight-bold mt-6 mb-2 grey-text text-darken-3">O' level Examination Results</h5>
            <div className="divider mb-5"></div>

            <div className="row">
                <div className="input-field col s6 m2 l2">
                     <select onChange={(e) => setMonth(e.target.value)} value={month}>
                        <option value="" disabled>Select</option>
                        <option value="January">January</option>
                        <option value="February">February</option>
                        <option value="March">March</option>
                        <option value="April">April</option>
                        <option value="May">May</option>
                        <option value="June">June</option>
                        <option value="July">July</option>
                        <option value="August">August</option>
                        <option value="September">September</option>
                        <option value="October">October</option>
                        <option value="November">November</option>
                        <option value="December">December</option>
                    </select>
                    <label>Month:</label>
                </div>
                <div className="input-field col s6 m2 l2">
                    <input id="year" type="text" onChange={(e) => setYear(e.target.value)} value={year} />
                    <label htmlFor="year" className="active">Year:</label>
                </div>
                <div className="input-field col s12 m4 l4">
                    <input id="subject" type="text" onChange={(e) => setSubject(e.target.value)} value={subject} />
                    <label htmlFor="subject" className="active">O' Level Subject:</label>
                </div>
                <div className="input-field col s6 m2 l2">
                    <input id="board" type="text" onChange={(e) => setBoard(e.target.value)} value={board} />
                    <label htmlFor="board" className="active">Exam Board:</label>
                </div>
                <div className="input-field col s6 m2 l2">
                    {/* <input id="grade" type="text" onChange={(e) => setGrade(e.target.value)} value={grade} />
                    <label htmlFor="grade" className="active">Results / Grade</label> */}
                     <select onChange={(e) => setGrade(e.target.value)} value={grade} >
                        <option value="" disabled>Select</option>
                        <option value="A">A</option>
                        <option value="B">B</option>
                        <option value="C">C</option>
                        <option value="D">D</option>
                        <option value="E">E</option>
                    </select>
                    <label>Grade:</label>
                </div>
            </div>
            {
                error && <p className="red-text text-darken-3">{error}</p>
            }
            <div className="control">
                <div className="button is-success mt-5"
                    onClick={addAcademic}
                >
                    <span className="icon">
                        <IoIosAddCircle size="1.25rem" color="white"/>
                    </span>
                    <span className="white-text">Add </span>
                </div>
            </div>
            {
                ordLevel.length !== 0 && <TableOne  ordLevel={ordLevel} setOrdLevel={setOrdLevel} />
            }
            <div className="mt-4 mb-4">
                <p className="grey-text text-darken-2"><span className="has-text-weight-bold">NB: </span>You need at least 5 subjects to proceed to the next step.</p>
            </div>
        </>
     );
}
 
export default Academics;